// extracted by mini-css-extract-plugin
module.exports = {"NoResultsContainer":"noResults_NoResultsContainer__SdAYP","extraPad":"noResults_extraPad__D_VRX"};